import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TrainingItemDetailsVM } from "@shared-kernel/application/ports/student/student-repository";
import type { TRAINING_ITEM_TYPE } from "@academy-context/shared/domain/types/training-items";

interface RetrieveTrainingItemDetailsParams {
  id: string;
  type: TRAINING_ITEM_TYPE;
}

export const studentRetrieveTrainingItemDetails = createAsyncThunk<
  TrainingItemDetailsVM,
  RetrieveTrainingItemDetailsParams,
  { extra: Partial<Dependencies> }
>("trainingItemDetails/studentRetrieveTrainingItemDetails", async ({ id, type }, { extra: { studentRepository } }) => {
  return studentRepository!.getTrainingItemById(id, type);
});
